import React,{useState} from 'react'
import Bookings from '../../CmsComponents/Bookings';
import CmsNavbar from '../../CmsComponents/CmsNavbar';
import CmsSidebar from '../../CmsComponents/CmsSidebar';


function BookingPage() {
    const [isOpen,setIsOpen]= useState(false);

    function HandleClicked() {
        setIsOpen(!isOpen);
    }

    return (
        <div>
            <CmsNavbar action={HandleClicked} />
            <CmsSidebar isOpen={isOpen} />
            <Bookings isOpen={isOpen} />
        </div>
    )
}

export default BookingPage;